export const SAVE_CONSIGNEE = "consignee/SAVE_CONSIGNEE";
export const GET_CONSIGNEES = "consignee/GET_CONSIGNEES";
export const SAVE_EXPORT_JOB = "account/SAVE_EXPORT_JOB";
export const GET_EXPORT_JOBS = "account/GET_EXPORT_JOBS";
export const EDIT_EXPORT_JOB = "account/EDIT_EXPORT_JOB";
export const DELETE_EXPORT_JOB = "account/DELETE_EXPORT_JOB";
export const GENERATE_CHECKLIST = "account/GENERATE_CHECKLIST";
export const GENERATE_FLATFILE = "account/GENERATE_FLATFILE";
